import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as moment from "moment";
// import CryptoJS from "crypto-js";

@Injectable()
export class WebService {
  private url = environment.API_BASE_URL;

  constructor(
    private http: HttpClient,
  ) { }

  // Request data from given url, return observable
  // request(url, data): Observable<any> {
  //   if (data == null) {
  //     data = {}
  //   }

  //   // const appVersion = navigator.appVersion;
  //   // const anonymousToken = this.loginService.getCookie("anonymousToken");
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       // 'Content-Type': 'multipart/form-data',
  //       'Access-Control-Allow-Origin': '*',
  //     })
  //   }
  //   return this.http.post(this.url + url, data, httpOptions)
  //   // .pipe(
  //   //     map(result => {
  //   //         return result;
  //   //     })
  //   // )
  // }

  request(url, data): Observable<any> {
    if (data == null) {
      data = {}
    }

    // const appVersion = navigator.appVersion;
    // const anonymousToken = this.loginService.getCookie("anonymousToken");
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
        
      })
    }
    return this.http.post(this.url + url, data, httpOptions)
    // .pipe(
    //     map(result => {
    //         return result;
    //     })
    // )
  }


  requestJson(url, data): Observable<any> {

    if (data == null) {
      data = {}
    }


    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text/plain',
        'Access-Control-Allow-Origin': '*',
  
      }),
      observe: "response" as "body",
      responseType: 'text' as "json"
    }
    return this.http.post(this.url + url, data, httpOptions)
    // .pipe(
    //     map(result => {
    //         return result;
    //     })
    // )
  }


  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  requestSyncFileJson(url, data): Observable<any> {

    if (data == null) {
      data = {}
    }


    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text/plain',
        'Access-Control-Allow-Origin': '*',
  
      }),
      observe: "response" as "body",
      responseType: 'text' as "json"
    }
    return this.http.post(this.url + url, data, httpOptions)
    // .pipe(
    //     map(result => {
    //         return result;
    //     })
    // )
  }
}